import { useSelector, useDispatch } from 'react-redux';

import { SelectSort, SwitchGridList } from '../../../shared/ui';

import { callModel } from '../../call';

import { ALL_OWNERS, SelectMember } from '../../team-members';

import { useCalendarSidebar, useCallsView } from '../hooks';
import { cn } from '@distribute/frontend/utils';

// Find a standalone way for sorting values

const sortMap = {
  createdAt: 'lastCreated',
  name: 'name',
} as const;

const sortReverseMap: Record<
  string,
  { sortBy: 'createdAt' | 'name'; sortOrder: 'ASC' | 'DESC' }
> = {
  lastCreated: {
    sortBy: 'createdAt',
    sortOrder: 'DESC',
  },
  name: {
    sortBy: 'name',
    sortOrder: 'ASC',
  },
} as const;

export const CallsFilters = () => {
  const { isMeetingEventsSidebarOpen } = useCalendarSidebar();

  const dispatch = useDispatch();

  const { view, setView } = useCallsView();

  const callListOptions = useSelector(
    callModel.selectors.selectCallListOptions
  );

  const handleOwnerChange = (ownerId: string) => {
    dispatch(
      callModel.actions.setListOptions({
        ...callListOptions,
        filterByMember: ownerId === ALL_OWNERS ? undefined : ownerId,
      })
    );
    dispatch(callModel.actions.loadCalls());
  };

  const handleSortChange = (sortId: string) => {
    const sort = sortReverseMap[sortId] ?? sortReverseMap.lastCreated;

    dispatch(
      callModel.actions.setListOptions({
        ...callListOptions,
        ...sort,
      })
    );
    dispatch(callModel.actions.loadCalls());
  };

  return (
    <div className="md:w-full md:ml-0 ml-auto flex flex-nowrap gap-x-3 items-center">
      {callListOptions.type === 'team' && (
        <SelectMember
          value={callListOptions.filterByMember}
          onChange={handleOwnerChange}
          className={cn('md:hidden', {
            'lg:hidden': isMeetingEventsSidebarOpen,
          })}
        />
      )}
      <SelectSort
        value={sortMap[callListOptions.sortBy ?? 'createdAt']}
        onChange={handleSortChange}
        className="md:w-full"
      />
      <SwitchGridList
        value={view}
        onChange={(value) => setView(value)}
        className="xl:hidden"
      />
    </div>
  );
};
